import React from 'react';

const TabContext = React.createContext({});

const useTab = (): any => React.useContext(TabContext);

export { useTab, TabContext };
